module.exports = __webpack_public_path__ + "img/tss-5.f6a8fcbd.jpg";